import { RouteObject } from 'react-router-dom'
import NiveisConsultorPage from '@/pages/niveis/NiveisConsultorPage'
import { SomenteBackoffice } from '../SomenteBackoffice'

/**
 * Rotas da AN-10 (Visão do Consultor, Onda 5 — DEV-R): página "Níveis" do back-office (o
 * consultor volta ao dashboard; ele vê o próprio nível no dashboard e no Perfil). Dentro da
 * página o recorte por persona continua: ADMIN tudo; GERENTE+GESTOR_EQUIPE só a aba
 * Atribuições da própria equipe, em leitura; GERENTE sem gestor e OPERADOR, sem permissão.
 */
const rotasAn10: RouteObject[] = [
  {
    path: 'niveis-consultor',
    element: (
      <SomenteBackoffice>
        <NiveisConsultorPage />
      </SomenteBackoffice>
    ),
  },
]

export default rotasAn10
